const defaultPrices = {
    full_books: 150.00,
    full_videos: 200.00,
    full_simulated: 80.00,
    combo_vip: 350.00,
    single_book: 25.00,
    single_video: 35.00,
    single_simulated: 15.00
};

export function getAdminPrices() {
    const saved = localStorage.getItem('admin_prices');
    if (saved) {
        try {
            return { ...defaultPrices, ...JSON.parse(saved) };
        } catch (e) {
            console.error("Erro ao processar preços do admin", e);
            return defaultPrices;
        }
    }
    return defaultPrices;
}

export function getLowestPrice() {
    const prices = getAdminPrices();
    // Exibe o menor preço unitário para frases 'A partir de R$...'
    return Math.min(prices.single_book, prices.single_video, prices.single_simulated);
}

export function getPriceByType(tipo) {
    const prices = getAdminPrices();
    const typeStr = (tipo || '').toLowerCase();
    
    if (typeStr.includes('livro') || typeStr === 'book' || typeStr === 'material-didatico') return prices.single_book;
    if (typeStr.includes('v\u00eddeo') || typeStr.includes('video') || typeStr === 'video-aula') return prices.single_video;
    if (typeStr.includes('simulado') || typeStr === 'simulated' || typeStr === 'atividade') return prices.single_simulated;
    
    return getLowestPrice();
}

export function getFullPackagePriceByType(tipo) {
    const prices = getAdminPrices();
    const typeStr = (tipo || '').toLowerCase();
    
    if (typeStr.includes('livro') || typeStr === 'book' || typeStr === 'material-didatico') return prices.full_books;
    if (typeStr.includes('v\u00eddeo') || typeStr.includes('video') || typeStr === 'video-aula') return prices.full_videos;
    if (typeStr.includes('simulado') || typeStr === 'simulated' || typeStr === 'atividade') return prices.full_simulated;
    
    return prices.combo_vip;
}

export function formatPrice(value) {
    if (value === undefined || value === null) return '0,00';
    return parseFloat(value).toFixed(2).replace('.', ',');
}
